import { tzOffset } from '@date-fns/tz';
import { addMinutes } from 'date-fns';

/**
 * Returns a timezone offset in minutes (mirrored to the timezone sign).
 */
export function timezoneOffsetToMinutes(
  siteTimeZone: string | null | undefined,
  date: Date
): number {
  if (!siteTimeZone) {
    return -date.getTimezoneOffset();
  }
  return tzOffset(siteTimeZone, date);
}

/**
 * Reinterprets a UTC timestamp so browser-local rendering shows wall-clock time
 * for a target site timezone.
 */
export function utcDateToTimezoneDisplayDate(
  utcDate: Date,
  siteTimeZone: string | null | undefined
): Date {
  const targetOffsetMinutes = timezoneOffsetToMinutes(siteTimeZone, utcDate);
  const userOffsetMinutes = -utcDate.getTimezoneOffset();
  const deltaMinutes = targetOffsetMinutes - userOffsetMinutes;

  return addMinutes(utcDate, deltaMinutes);
}
